<template>
  <fieldset class="mt-3">
    <div class="row mt-3">
      <div class="col-12">
        <div class="form-check form-switch">
          <input
            id="howitwork-toggle"
            v-model="howItWorks.status"
            class="form-check-input"
            type="checkbox"
            @change="$emit('toggleHowItWork')"
          />
          <label class="form-check-label" for="howitwork-toggle"
            >How It Works</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <span class="d-block">Content</span>
        <button
          v-show="showHideAddMoreHowItWork"
          class="btn btn-outline-dark mt-2"
          @click="addMoreHowItWork"
        >
          Add More
        </button>
      </div>
      <div class="row">
        <div class="col-6">
          <fieldset>
            <div
              v-for="(content, index) in howItWorks.content"
              :key="index"
              class="card mt-3"
            >
              <div class="card-body">
                <img
                  alt="Close"
                  class="cursor-pointer mb-2 float-right"
                  src="@/assets/icons/icon-close.svg"
                  @click="removeHowItWork(index)"
                />
                <div class="row">
                  <div class="col">
                    <fieldset>
                      <span>Title</span>
                      <div class="card mt-3">
                        <div class="card-body">
                          <div class="form-group full-width">
                            <label>Text</label>
                            <textarea
                              v-model="content.title"
                              class="form-control mt-2"
                              required
                              rows="6"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col">
                    <fieldset>
                      <span>Description</span>
                      <div class="card mt-3">
                        <div class="card-body">
                          <div class="form-group full-width">
                            <label>Text</label>
                            <textarea
                              v-model="content.description"
                              class="form-control mt-2"
                              required
                              rows="6"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-6">
          <fieldset>
            <div class="card mt-3">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <fieldset>
                      <span>Title</span>
                      <div class="card mt-3">
                        <div class="card-body">
                          <div class="form-group full-width">
                            <label>Text</label>
                            <textarea
                              v-model="howItWorks.title"
                              class="form-control mt-2"
                              required
                              rows="6"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col">
                    <fieldset>
                      <span>Button One</span>
                      <div class="card mt-3">
                        <div class="card-body">
                          <div class="form-group full-width">
                            <label>Text</label>
                            <input
                              type="text"
                              v-model="howItWorks.btn_one.text"
                              class="form-control mt-2"
                              required
                            />
                          </div>
                          <div class="form-group full-width mt-3">
                            <label>Url</label>
                            <input
                              type="url"
                              v-model="howItWorks.btn_one.url"
                              class="form-control mt-2"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col">
                    <fieldset>
                      <span>Button Two</span>
                      <div class="card mt-3">
                        <div class="card-body">
                          <div class="form-group full-width">
                            <label>Text</label>
                            <input
                              type="text"
                              v-model="howItWorks.btn_two.text"
                              class="form-control mt-2"
                              required
                            />
                          </div>
                          <div class="form-group full-width mt-3">
                            <label>Url</label>
                            <input
                              type="url"
                              v-model="howItWorks.btn_two.url"
                              class="form-control mt-2"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "HowItWorks",
  props: {
    howItWorksData: { type: Object }
  },
  data() {
    return {
      howItWorks: this.howItWorksData
    };
  },
  methods: {
    addMoreHowItWork() {
      this.howItWorks.content.push({
        title: "",
        description: ""
      });
    },
    removeHowItWork(index) {
      this.$delete(this.howItWorks.content, index);
    }
  },
  watch: {
    howItWorks: {
      handler(val) {
        this.$emit("update-howitworks", val);
      },
      deep: true
    }
  },
  computed: {
    /** Show Hide Add More Button Section */
    showHideAddMoreHowItWork() {
      let target = this.howItWorks.content;
      let len = target.length;
      if (len > 0) {
        if (len === 4) return false;
        let content = target[len - 1];
        if (content.title.trim() === "") {
          return false;
        }
        if (content.description.trim() === "") {
          return false;
        }
        return true;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-footer-title {
  min-height: 285px;
}
.card-fixed {
  height: auto;
  max-height: 650px;
  overflow-y: auto;
}
.card-body {
  min-height: 250px;
}
.card-body-title {
  color: #6c757d;
  display: inline-block;
  margin-bottom: 10px;
}
.full-width {
  max-width: 100%;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
}
.form-group {
  textarea {
    line-height: 20px;
  }
}
.form-switch {
  padding-left: 0;
  .form-check-input {
    margin: 0;
  }
  .form-check-label {
    cursor: pointer;
  }
}
</style>
